module.exports =
{
    apiBaseUrl: process.env.NODE_ENV === 'development' ? 'https://localhost:5001' : window.location.origin,
    requestTimeout: 30000
}